import { ErrorInterface } from '../../interfaces/general.interface';

export interface LoginCredentialsState {
  error: boolean | ErrorInterface;
  loading: boolean;
  response: boolean;
}

export const initialLoginCredentialsState: LoginCredentialsState = {
  error: false,
  loading: false,
  response: false,
};
